import { Box, useTheme } from '@mui/material';
import { KitItem } from '../types';
import CompliancePlip from '../../../../components/CompliancePlip';
import RefillStatus from './RefillStatus';
import { itemImages } from '../../../../helpers/image';
import { MedicationStatusMessage } from '../../../../enums';

const STATUS_CODE_MAP: Record<number, string> = {
  1: MedicationStatusMessage.UpToDate,
  2: MedicationStatusMessage.Expiring,
  3: MedicationStatusMessage.Expired,
  4: MedicationStatusMessage.Inactive
};

const getMedicationStatusMessage = (code: number): string => {
  return STATUS_CODE_MAP[code] || 'Unknown status';
};

const getItemImage = (image: string | null) => {
  if (image) {
    const itemImage = itemImages[`${image}.jpg`];
    return itemImage;
  }
  return itemImages['no_image.png'];
};

const Item = ({ item }: { item: KitItem }) => {
  const theme = useTheme();
  const medicationStatusMessage = getMedicationStatusMessage(item.status);

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '12px 16px',
        borderBottom: 1,
        borderBottomColor: theme.palette.colordee5e7.main
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Box sx={{ display: 'flex', width: '50px', justifyContent: 'center' }}>
          <img src={getItemImage(item?.item?.images)} alt="kit" style={{ width: 'auto', maxWidth: '50px', maxHeight: '50px' }} className="m-r-12" />
        </Box>
        <CompliancePlip message={medicationStatusMessage} status={item.status} className="m-r-12" />
        <span className="m-r-8 f-s-15">
          {item.quantity} {item?.item?.name ?? ''}
        </span>{' '}
        <span className="f-s-13">
          (Lot#: {item.lot_number}, Item#:{item.item_number})
        </span>
      </Box>
      <RefillStatus item={item} />
    </Box>
  );
};

export default Item;
